import { apiRequest } from '../../../api-client';

const getIntegrationLabels = ({
  enterpriseId,
  connectionId,
  projectId,
  token
}: {
  enterpriseId: string;
  connectionId: string;
  projectId: string;
  token?: string;
}) => {
  return apiRequest<string[]>({
    endpoint: `/api/integrations/enterprises/${enterpriseId}/connections/${connectionId}/labels?project_id=${projectId}`,
    token
  });
};

export default getIntegrationLabels;
